<template>
  <div class="general-wrapper">
    <Header>
      <template #title>
        <div class="gap-column-1xs">
          <div>{{ $t(`navbar.${$route.name}`) }}</div>
          <div class="qrw-label-badge beta-badge qrw-label-xs">beta</div>
        </div>
      </template>

      <template #actions>
        <div class="iqos-tooltip-helper-box">
          <BasePushButton
            variant="primary"
            bold
            bgColor="foundation-orange-400"
            textColor="content-base-inverse-primary"
            icon="qr-code"
            @click="show_test_qr_code = !show_test_qr_code"
            size="sm"
          >
            {{ $t("inside.test_button") }}
          </BasePushButton>

          <IQOSTooltip
            :title="$t('inside.test_button')"
            earPosition="top-right"
            size="sm"
            :qrLink="testOrderLink"
            @close="show_test_qr_code = false"
            v-if="show_test_qr_code"
          >
            <div style="text-align: center;">
              {{ $t("inside.test_tooltip") }}
            </div>
          </IQOSTooltip>
        </div>
      </template>
    </Header>

    <PageContainer contentClass="gap-row-md new-reserve-container">
      <div class="gap-row-sm">
        <div class="qrw-heading-xs bold qrw-text-content-base-primary">
          {{ $t("mode_settings.required") }}
        </div>

        <div class="iqos-grid">
          <div class="iqos-column">
            <PhoneConfirmationPanel />
          </div>
          <div class="iqos-column">
            <AutoCancelPanel :mode="'reserve'" />
          </div>
        </div>
      </div>

      <BaseDivider color="border-base-tertiary" />
      <div class="gap-row-sm">
        <div class="qrw-heading-xs bold qrw-text-content-base-primary">
          {{ $t("mode_settings.optional") }}
        </div>

        <div class="iqos-grid">
          <div class="iqos-column">
            <DepositSettings />
          </div>
          <div class="iqos-column">
            <ReserveAllowToday />
          </div>
        </div>
      </div>
    </PageContainer>
  </div>
</template>

<script>
import AutoCancelPanel from "@/components/general/AutoCancelPanel.vue";
import ReserveAllowToday from "@/components/reserve/ReserveAllowToday.vue";
import DepositSettings from "@/components/reserve/DepositSettings.vue";
import PhoneConfirmationPanel from "@/components/general/PhoneConfirmationPanel.vue";

export default {
  components: {
    AutoCancelPanel,
    ReserveAllowToday,
    DepositSettings,
    PhoneConfirmationPanel,
  },
  data() {
    return {
      show_test_qr_code: false,
    };
  },
  computed: {
    testOrderLink() {
      return `https://new.qrwaiter.com.ua/${this.$store.state.cafe.online_menu_link}`;
    },
  },
};
</script>

<style>
.new-reserve-container {
  padding: 24px 52px 52px 52px !important;
}
</style>

<style scoped>
.beta-badge {
  padding: 1px 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--qrw-content-base-inverse-primary);
  background: var(--qrw-background-error-default);
  align-self: flex-start;
  border-radius: 3px;
}
</style>
